import { z } from "zod"

import { issueSeverities, issueStatuses } from "@/features/issues/issue-labels"
import type { IssueFilters } from "@/types/issue"

/** Every issue list's URL state. With no status, anything not yet closed. */
const issueSearchSchema = z.object({
  status: z.enum(issueStatuses).optional().catch(undefined),
  severity: z.enum(issueSeverities).optional().catch(undefined),
  q: z.string().optional().catch(undefined),
  page: z.coerce.number().int().positive().optional().catch(undefined),
})

type IssueSearch = z.infer<typeof issueSearchSchema>

function issueFilters(
  search: IssueSearch,
  scope: Pick<IssueFilters, "firm_id" | "individual_id"> = {}
): IssueFilters {
  return {
    ...scope,
    status: search.status,
    open: search.status ? undefined : true,
    severity: search.severity,
    q: search.q,
    page: search.page,
  }
}

export { issueFilters, issueSearchSchema }
export type { IssueSearch }
